export default (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#FF4500" />
    <path
      d="M19.2 12a1.62 1.62 0 0 0-2.74-1.17 7.94 7.94 0 0 0-4.03-1.26l.7-3.28 2.28.48a1.16 1.16 0 1 0 .13-.6l-2.62-.56a.3.3 0 0 0-.36.23l-.79 3.72a7.95 7.95 0 0 0-4.1 1.27A1.62 1.62 0 1 0 5.9 13.6a3.1 3.1 0 0 0-.04.5c0 2.5 2.76 4.52 6.16 4.52s6.16-2.02 6.16-4.51c0-.17-.01-.34-.04-.5A1.62 1.62 0 0 0 19.2 12ZM8.7 13.16a1.16 1.16 0 1 1 1.16 1.15 1.16 1.16 0 0 1-1.15-1.15Zm6.53 3.08a4.3 4.3 0 0 1-2.72.75h-.02a4.3 4.3 0 0 1-2.72-.75.31.31 0 0 1 .43-.44 3.7 3.7 0 0 0 2.3.6 3.7 3.7 0 0 0 2.3-.6.31.31 0 1 1 .43.44Zm-.1-1.92a1.16 1.16 0 1 1 0-2.31 1.16 1.16 0 0 1 0 2.3Z"
      fill="white"
    />
  </svg>
);
